import { render, staticRenderFns } from "./RoutePage.vue?vue&type=template&id=228c8b84&scoped=true&"
import script from "./RoutePage.vue?vue&type=script&lang=js&"
export * from "./RoutePage.vue?vue&type=script&lang=js&"
import style0 from "./RoutePage.vue?vue&type=style&index=0&id=228c8b84&scoped=true&lang=css&"
import style1 from "./RoutePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c8b84",
  null
  
)

export default component.exports